import React from 'react';
import { errorId } from '@rjsf/utils';
import styles from '../rjsf.module.css';

/** Renders the errors local to a single field, styled as a small red list below it. */
const FieldErrorTemplate = ({ errors = [], idSchema }) => {
  if (errors.length === 0) {
    return null;
  }
  return (
    <ul id={errorId(idSchema)} className={styles.fieldErrors}>
      {errors.filter(Boolean).map((error, index) => (
        <li key={index} className={styles.fieldError}>
          {error}
        </li>
      ))}
    </ul>
  );
};

export default FieldErrorTemplate;
